import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  notStarted: boolean
  inProgress: boolean
  completed: boolean
  finalised: boolean
}

export const DEFAULT_FILTER: Filter = {
  notStarted: false,
  inProgress: false,
  completed: false,
  finalised: false,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const JourneyStageFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Not started"
      checked={filter.notStarted}
      onChange={e =>
        onChangeFilter({
          ...filter,
          notStarted: e.target.checked,
        })
      }
    />
    <Checkbox
      label="In progress"
      checked={filter.inProgress}
      onChange={e =>
        onChangeFilter({
          ...filter,
          inProgress: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Completed"
      checked={filter.completed}
      onChange={e =>
        onChangeFilter({
          ...filter,
          completed: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Finalised"
      checked={filter.finalised}
      onChange={e =>
        onChangeFilter({
          ...filter,
          finalised: e.target.checked,
        })
      }
    />
  </>
)

export default JourneyStageFilter
